import { useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Descriptions, Flex, Image, Row, Typography } from "antd";
import { useParams } from "react-router";
import { surveyService } from "../../services/survey.service";
import { Icon } from "@iconify/react/dist/iconify.js";
import pallete from "../../utils/pallete";

export default function ProcessDocumentAnalysisDetail(){

  const { id } = useParams()

  const { data: surveyData } = useQuery({
    queryKey: ['detailCanceledDataSurvey', id],
    queryFn: () => surveyService.getRejectedDataById(id),
    enabled: !!id
  })

  return (
    <>
      <Card
        title="Detail Data Tercancel"
      >
        <Descriptions
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          style={{ marginBottom: 20 }}
          title="Informasi Pelanggan"
          items={[
            { label: 'Nama Pelanggan', children: surveyData?.data?.nama },
            { label: 'No Telepon', children: surveyData?.data?.telepon },
            { label: 'Email', children: surveyData?.data?.email },
            { label: 'Kota', children: surveyData?.data?.kota },
            { label: 'Kecamatan', children: surveyData?.data?.kecamatan },
            { label: 'Kelurahan', children: surveyData?.data?.kelurahan },
            { label: 'Jalan', children: surveyData?.data?.jalan },
            { span: 0.5, label: 'No Rumah', children: surveyData?.data?.no_rumah },
            { span: 0.5, label: 'RT', children: surveyData?.data?.rt },
            { span: 0.5, label: 'RW', children: surveyData?.data?.rw },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Titik Lokasi Koordinat"
          items={[
            { label: 'Titik Lokasi Koordinat', children: surveyData?.data?.lokasi_bangunan },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Lokasi"
          items={[
            { label: 'PA/PC',  children: surveyData?.data?.pa_pc },
            { label: 'BLOK/EZ', span: 0.5, children: surveyData?.data?.blok_ez },
            { label: 'NOVAK/BLOK', span: 0.5, children: surveyData?.data?.novak_blok },
            { label: 'Sumber air lain yang digunakan pelanggan', span: 2, children: surveyData?.data?.sumber_lain },
            { label: 'Jaringan Pipa', children: surveyData?.data?.jaringan_pipa },
            { label: 'Jarak bangunan dengan pipa existing PAM JAYA', children: surveyData?.data?.jarak_bangunan_dengan_pipa },
            { label: 'Ukuran Pipa Input ', children: surveyData?.data?.ukuran_pipa },
            { label: 'Diameter Pipa Dinas yang akan dipasang', children: surveyData?.data?.diameter_pipa },
            { label: 'Jenis jalan/gailan', children: surveyData?.data?.jenis_jalan },
            { label: 'Perlu crosing jalan', children: surveyData?.data?.perlu_crossing_jalan },
            { label: 'Lebar Jalan', children: surveyData?.data?.lebar_jalan },
            { label: 'Perlu crossing saluran air', children: surveyData?.data?.perlu_crossing_air },
            { label: 'Panjang casing pipa', children: surveyData?.data?.panjang_casing_pipa },
            { label: 'Halaman', children: surveyData?.data?.halaman },
            { label: 'Sanitasi', span: 0.5, children: surveyData?.data?.sanitasi },
            { label: 'Saluran Pembuangan', span: 0.5, children: surveyData?.data?.saluran_pembuangan },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Bangunan"
          items={[
            { label: 'Kamar Tidur',  children: surveyData?.data?.kamar_tidur },
            { label: 'Kamar Mandi',  children: surveyData?.data?.kamar_mandi },
            { label: 'Ruang Tamu',  children: surveyData?.data?.ruang_tamu },
            { label: 'Ruang Makan',  children: surveyData?.data?.ruang_makan },
            { label: 'Ruang Keluarga',  children: surveyData?.data?.ruang_keluarga },
            { label: 'Dapur',  children: surveyData?.data?.dapur },
            { label: 'Teras',  children: surveyData?.data?.teras },
            { label: 'Garasi',  children: surveyData?.data?.garasi },
            { label: 'Gudang/Paviliun',  children: surveyData?.data?.gudang },
            { label: 'Lantai',  children: surveyData?.data?.jumlah_lantai },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Bangunan"
          items={[
            { label: 'Kamar Tidur',  children: surveyData?.data?.kamar_tidur },
            { label: 'Kamar Mandi',  children: surveyData?.data?.kamar_mandi },
            { label: 'Ruang Tamu',  children: surveyData?.data?.ruang_tamu },
            { label: 'Ruang Makan',  children: surveyData?.data?.ruang_makan },
            { label: 'Ruang Keluarga',  children: surveyData?.data?.ruang_keluarga },
            { label: 'Dapur',  children: surveyData?.data?.dapur },
            { label: 'Teras',  children: surveyData?.data?.teras },
            { label: 'Garasi',  children: surveyData?.data?.garasi },
            { label: 'Gudang/Paviliun',  children: surveyData?.data?.gudang },
            { label: 'Lantai',  children: surveyData?.data?.jumlah_lantai },
          ]}
        />
        <Descriptions
          style={{ marginBottom: 20 }}
          column={1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Dokumen"
          items={[
            { 
              label: 'Surat Pelayanan Sementara', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.serviceLetter.fileName}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                  >
                    Unduh
                  </Button>
                  <Button 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                  >
                    Lihat
                  </Button>
                  
                </Flex>
              )
            },
            { 
              label: 'Dokumen Pendukung', 
              children: (
                <Flex gap={8} >
                  <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.serviceLetter.fileName}</Typography.Text>
                  <Button 
                    icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                  >
                    Unduh
                  </Button>
                  <Button 
                    variant="filled" 
                    color="primary" 
                    size="small" 
                    style={{ fontSize: 12 }} 
                    icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                  >
                    Lihat
                  </Button>
                  
                </Flex>
              )
            },
            ...surveyData?.data?.additionalLetter.map(
              (e,i) => ({
                label: i == 0 ? 'Dokumen Pendukung' : '',
                children: (
                  <Flex gap={8} >
                    <Typography.Text style={{ marginRight: 'auto' }}>{e.fileName}</Typography.Text>
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      Unduh
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                    >
                      Lihat
                    </Button>
                    
                  </Flex>
                )
              })
            ) ?? []
          ]}
        />
        <Typography.Title level={5} >
          Persetujuan
        </Typography.Title>
        <Row>
          <Col span={12} >
            <Flex vertical align="center" >
              <Image
                src={surveyData?.data?.tanda_tangan_pelanggan}
                preview={false}
              />
              <Typography.Text>
                {surveyData?.data?.nama}
              </Typography.Text>
              <Typography.Text style={{ color: pallete.primary.main }} >
                Pelanggan
              </Typography.Text>
            </Flex>
          </Col>
          <Col span={12} >
            <Flex vertical align="center" >
              <Image
                src={surveyData?.data?.tanda_tangan_surveyor}
                preview={false}
              />
              <Typography.Text>
                {surveyData?.data?.acceptance.surveyor.name}
              </Typography.Text>
              <Typography.Text style={{ color: pallete.primary.main }} >
                Surveyor
              </Typography.Text>
            </Flex>
          </Col>
        </Row>
      </Card>
    </>
  ) 
}